import Toggle from "../../components/Toggle/Toggle";
import Typography from "../../components/Typography/Typography";


const PreferencesSection = ({ userData }) => {
  return (
    <div className="w-100 flex w-full flex-col items-end gap-9">
      <div className="w-full flex flex-col gap-3">
        <Typography size="20" weight="sb">Conservazione dei dati AI</Typography>
        <div className="flex gap-9 items-center w-full justify-between">
          <Typography size="16" color="gray-600">
            La conservazione dei dati AI consente ad Athena di utilizzare le tue ricerche per migliorare i modelli di intelligenza artificiale.
            Disattiva questa impostazione se desideri escludere i tuoi dati da questo processo.
          </Typography>
          <Toggle id="conservazione-dati-ai" checked={userData?.ExtraInfo || false} />
        </div>
      </div>
      <div className="w-full flex flex-col gap-3">
        <Typography size="20" weight="sb">
          Email
        </Typography>
        <div className="flex gap-9 items-center w-full justify-between">
          <Typography size="16" color="gray-600">
            Non inviamo spam. Ti contatteremo solo se strettamente necessario.
            Alcune email relative alla tua password non possono essere disattivate per garantire la tua sicurezza.
          </Typography>
          <Toggle id="email" checked={true} />
        </div>
      </div>
    </div>
  );
};

export default PreferencesSection;